// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-icon[data-v-03b98a6f] {\n  margin-left: 0.75rem;\n}\n.reveal-icon[data-v-03b98a6f] {\n  height: 1rem;\n  width: 1rem;\n  color: #C1C1C1;\n}\n.reveal-icon--active[data-v-03b98a6f] {\n  color: var(--primary);\n}\n.toggle-password[data-v-03b98a6f] {\n  background: none;\n  border: none;\n}\n.toggle-password[data-v-03b98a6f]:focus {\n  outline: none;\n}", ""]);
// Exports
module.exports = exports;
